import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import LangLink from "../../LangLink";
import "./AboutMegaMenu.css";

const aboutItems = [
  { id: "whoWeAre", to: "/about" },
  { id: "careers", to: "/careers" },
  { id: "blog", to: "/blog" },
  { id: "downloads", to: "/downloads" },
  { id: "academy", to: "/academy" },
  { id: "contactUs", to: "/contactus" },
];

const AboutMegaMenu = () => {
  const { t } = useTranslation();

  return (
    <div className="aboutMegaMenu">
      <div className="aboutMegaMenu-header">
        <h3>{t("navbar.aboutUs")}</h3>
        <p>{t("navbar.aboutMenu.description")}</p>
      </div>

      <div className="aboutMegaMenu-grid">
        {aboutItems.map((item) => (
          <LangLink to={item.to} className="aboutMegaMenu-card" key={item.id}>
            <div className="aboutMegaMenu-cardTop">
              <h4>{t(`navbar.aboutMenu.${item.id}`)}</h4>
              <FiArrowUpRight />
            </div>
            <p>{t(`navbar.aboutMenu.${item.id}Subtitle`)}</p>
          </LangLink>
        ))}
      </div>
    </div>
  );
};

export default AboutMegaMenu;
